module.exports = __webpack_public_path__ + "static/media/chat-icon-close.9f62854c.svg";